import api from "../../utils/apiUserTienda";

export const getSubcategorias = async () => {
  const res = await api.get("/api/tienda/subcategorias/obtener");
  return res.data.subcategorias;
};

export const createSubcategoria = async (data) => {
  const res = await api.post("/api/tienda/subcategorias/crear", data);
  return res.data;
};

export const updateSubcategoria = async (id, data) => {
  const res = await api.put(`/api/tienda/subcategorias/actualizar/${id}`, data);
  return res.data;
};

export const getSubcategoriasActivas = async () => {
  const res = await api.get("/api/tienda/subcategorias/obtener/activas");
  return res.data.subcategorias;
};

export const getSubcategoriasActivasPorCategoria = async (categoriaId) => {
  const cid = Number(categoriaId);
  if (!cid || !Number.isFinite(cid)) {
    return [];
  }
  const res = await api.get(`/api/tienda/subcategorias/obtener/activas/por/categoria/${cid}`);
  return res.data.subcategorias ?? [];
};
